import React from "react";
import { IndexedDbSongRepository, SongRepository } from "./SongRepository";

const defaultSongRepository = new IndexedDbSongRepository();
export const SongRepositoryContext = React.createContext<SongRepository>(defaultSongRepository);